import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getCommunitySummaryCard } from 'constants/routes'

/**
 * Retrieves community summary information from a given id.
 * @param {Object} communityId - community identifier to query.
 * @param {Object} marketId - market identifier to query.
 * @returns {Observable} - An observable that emits the commuinty summary information.
 */
const getCommunitySummaryCardInformation = (communityId, marketId) => {
  const params = new URLSearchParams();
  params.append('id', communityId);

  if (marketId) {
    params.append('marketId', marketId);
  }

  const url = `${getCommunitySummaryCard}?${params.toString()}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json())
  );
};

export default getCommunitySummaryCardInformation;